import { Get, Post, Patch } from './http.svc'

export const getSwmsTemplates = () => Get('swms-templates')

export const createSwmsTemplate = (templateData) => Post('swms-templates', templateData)

export const updateSwmsTemplate = (templateId, templateData) => Patch(`swms-templates/${templateId}`, templateData)

export const activateSwmsTemplate = (templateId) => Patch(`swms-templates/${templateId}/activate`)

export const deactivateSwmsTemplate = (templateId) => Patch(`swms-templates/${templateId}/deactivate`)

export const getSwmsTemplateUrl = (templateId) => Get(`swms-templates/${templateId}/url`)
